import { render, staticRenderFns } from "./CriarNotaAvulsaView.vue?vue&type=template&id=505ae778"
import script from "./CriarNotaAvulsaView.vue?vue&type=script&lang=js"
export * from "./CriarNotaAvulsaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports